var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0175 16.4759H11.4118C10.6321 16.4759 10 17.1771 10 18.0421V21.9577C10 22.8227 10.6321 23.524 11.4118 23.524H14.0175C14.1595 23.524 14.2981 23.5715 14.4153 23.6602L19.7931 27.7278C20.4373 28.215 21.3156 28.0306 21.7548 27.3158C21.9145 27.0558 22 26.7484 22 26.4337V13.5662C22 12.7012 21.3679 12 20.5882 12C20.3045 12 20.0275 12.0948 19.7931 12.2721L14.4153 16.3396C14.2981 16.4284 14.1595 16.4758 14.0175 16.4759V16.4759Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2762 19.9998L29.2924 18.9836C29.5732 18.703 29.5733 18.2479 29.2927 17.9672C29.2926 17.9672 29.2925 17.9671 29.2924 17.967L28.7843 17.4589C28.5037 17.1782 28.0487 17.1781 27.768 17.4587C27.7679 17.4588 27.7678 17.4588 27.7678 17.4589L26.7515 18.4751L25.7353 17.4589C25.4547 17.1782 24.9996 17.1781 24.7189 17.4587C24.7189 17.4588 24.7188 17.4588 24.7187 17.4589L24.2106 17.967C23.9299 18.2476 23.9298 18.7027 24.2104 18.9834L24.2106 18.9836L25.2268 19.9998L24.2106 21.016C23.9299 21.2966 23.9298 21.7517 24.2104 22.0324L24.2106 22.0326L24.7187 22.5407C24.9993 22.8215 25.4544 22.8216 25.7351 22.541C25.7352 22.5409 25.7352 22.5408 25.7353 22.5407L26.7515 21.5245L27.7678 22.5407C28.0484 22.8215 28.5034 22.8216 28.7841 22.541L28.7843 22.5407L29.2924 22.0326C29.5732 21.752 29.5733 21.297 29.2927 21.0163C29.2926 21.0162 29.2925 21.0161 29.2924 21.016L28.2762 19.9998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.e564764aafd841429ae64964c568d38b.svg";
export { ForwardRef as ReactComponent };